import { render, staticRenderFns } from "./auditlog.vue?vue&type=template&id=34a63065&scoped=true&"
import script from "./auditlog.vue?vue&type=script&lang=ts&"
export * from "./auditlog.vue?vue&type=script&lang=ts&"
import style0 from "./auditlog.vue?vue&type=style&index=0&id=34a63065&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a63065",
  null
  
)

export default component.exports